import { Component, Input } from '@angular/core';
import { CardSecondaryTextKey } from './card-secondary-texts/card-secondary-texts.component';

@Component({
  selector: 'app-card-secondary',
  templateUrl: './card-secondary.component.html',
  styleUrl: './card-secondary.component.scss'
})
export class CardSecondaryComponent {
  @Input()
  titleKey: CardSecondaryTextKey;
}
